<template>
<div id="app">
  <w-app>
<!--Header Code-->
    <header>
      <!--Logo-->
      <div class="center-screen">
      <img src="./assets/Station49new.png" height="150" style="border-radius: var(--radius-md); filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));">
      <br>
      <br>
      <w-button class="ma1" bg-color="secondary" width="150" height="100" shadow text xl @click="">Self-Serve<br>Credits</w-button>
      </div>
    </header>

<!--Center Section-->
    <main class="grow">

      <!--Scan Card-->
      <div v-show="userPage">
        <div class="center-screen">
          <img src="./assets/front2.jpg" height="300">
        </div>
        <br>
        <div class="center-screen">
          <w-button class="ma1" bg-color="primary" width="150"
          :height="75" shadow text xl @click="showOverlay = true" v-show=noUser>Scan QR Code</w-button>
        </div>
      </div>

      <!--Card Scanned Screen-->
      <div v-show="goKart">
        <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="150" height="30" shadow text xl @click="">Card Number:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="150" height="30" shadow text xl @click="">{{this.cardNum}}</w-button>
        </div>
        <div class="center-screen">
          <w-button class="ma1" bg-color="secondary" width="150" height="30" shadow text xl @click="">Current Credits:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="150" height="30" shadow text xl @click="">{{this.credits}}</w-button>
        </div>
        <br>
        <div class="center-screen">
          <w-button class="ma1" bg-color="primary" width="150" height="50" shadow text xl @click="pageSwitch(-1);clear();clearAdd();"> <w-icon class="mr2">wi-cross</w-icon>Go Back</w-button>
          <br>
          <w-button class="ma1" bg-color="success" width="150" height="50" shadow text xl @click="pageSwitch(1)"> <w-icon class="mr2">wi-check</w-icon>Add Credits</w-button>
        </div>
      </div>

      <!--Add Points Screen-->
      <div v-show="miniGolf">
        <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="150" height="30" shadow text xl @click="">Card Number:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="150" height="30" shadow text xl @click="">{{this.cardNum}}</w-button>
        </div>
        <div class="center-screen">
          <w-button class="ma1" bg-color="secondary" width="150" height="30" shadow text xl @click="">Current Credits:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="150" height="30" shadow text xl @click="">{{this.credits}}</w-button>
        </div>
        <div class="center-screen">
          <w-button class="ma1" bg-color="primary" width="300" height="30" shadow text xl @click="attractions = true">View Attraction Credit Pricing</w-button>
        </div>
        <!--Row 1-->
        <div class="center-screen">
          <w-button class="ma1" bg-color="warning" width="200"
          :height="50" shadow text xl @click="incrementCart('addPkg1')">100 Credits + 10 Free<br>$100</w-button>
          <w-button class="ma1" bg-color="outline-primary" width="50"
          :height="30" shadow text xl @click="showPkg1 = true">{{this.addPkg1}}</w-button>
        </div>
        <!--Row 2-->
        <div class="center-screen">
          <w-button class="ma1" bg-color="warning" width="200"
          :height="50" shadow text xl @click="incrementCart('addPkg2')">150 Credits + 20 Free<br>$150</w-button>
          <w-button class="ma1" bg-color="outline-primary" width="50"
          :height="30" shadow text xl @click="showPkg2 = true">{{this.addPkg2}}</w-button>
        </div>
        <!--Row 3-->
        <div class="center-screen">
          <w-button class="ma1" bg-color="warning" width="200"
          :height="50" shadow text xl @click="incrementCart('addPkg3')">250 Credits + 40 Free<br>$250</w-button>
          <w-button class="ma1" bg-color="outline-primary" width="50"
          :height="30" shadow text xl @click="showPkg3 = true">{{this.addPkg3}}</w-button>
        </div>
        <!--Row 4-->
        <div class="center-screen">
          <w-button class="ma1" bg-color="warning" width="200"
          :height="50" shadow text xl @click="incrementCart('addPkg4')">500 Credits + 100 Free<br>$500</w-button>
          <w-button class="ma1" bg-color="outline-primary" width="50"
          :height="30" shadow text xl @click="showPkg4 = true">{{this.addPkg4}}</w-button>
        </div>
        <!--Row 5-->
        <div class="center-screen">
         <w-button class="ma1" bg-color="warning" width="200"
          :height="50" shadow text xl @click="incrementCart('addOther')">Individual Credits<br>$1</w-button>
          <w-button class="ma1" bg-color="outline-primary" width="50"
          :height="30" shadow text xl @click="showOther = true">{{this.addOther}}</w-button>
        </div>

        <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl @click="">Credits Being Purchased:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="75" height="30" shadow text xl @click="">{{this.totalAdd}}</w-button>
        </div>
        <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl @click="">Credits After Checkout:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="75" height="30" shadow text xl @click="">{{this.totalAfter}}</w-button>
        </div>
        <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl @click="">Subtotal:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="75" height="30" shadow text xl @click="">${{this.subtotal}}</w-button>
        </div>
        <div class="center-screen">
        <w-button class="ma1" bg-color="primary" width="100"
        :height="50" shadow text xl @click="pageSwitch(-1);clear();clearAdd();">Back</w-button>
        <w-button class="ma1" bg-color="error" width="100"
        :height="50" shadow text xl @click="clearAdd()">Clear Cart</w-button>
        <w-button v-show=!noUser class="ma1" bg-color="success" width="100"
        :height="50" shadow text xl @click="loadCheckoutTotals();">Checkout</w-button>
      </div>
    </div>

    <!--Wristband Info Screen-->
    <div v-show="bandInfo">
      <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="150" height="30" shadow text xl>Wristband:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="150" height="30" shadow text xl>{{this.cardNum}}</w-button>
      </div>
      <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="200" height="30" shadow text xl>Time Remaining:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="200" height="30" shadow text xl>{{this.bandTimeRemaining}}</w-button>
      </div>
      <br>
      <div class="center-screen">
        <w-button class="ma1" bg-color="warning" width="250" :height="60" shadow text xl
          @click="selectBandPackage('band90')">90-Minute Extension<br>$25</w-button>
      </div>
      <div v-if="bandType === 'big' || bandType === null" class="center-screen">
        <w-button class="ma1" bg-color="warning" width="250" :height="60" shadow text xl
          @click="selectBandPackage('bandBig')">Big 3 Hours<br>$55</w-button>
      </div>
      <div v-if="bandType === 'small' || bandType === null" class="center-screen">
        <w-button class="ma1" bg-color="warning" width="250" :height="60" shadow text xl
          @click="selectBandPackage('bandSmall')">Small 3 Hours<br>$45</w-button>
      </div>
      <br>
      <div class="center-screen">
        <w-button class="ma1" bg-color="primary" width="100" :height="50" shadow text xl
          @click="pageSwitch(-1);clear();clearAdd();">
          <w-icon class="mr2">wi-cross</w-icon>Go Back
        </w-button>
      </div>
    </div>

    <!--Checkout Screen-->
    <div v-show="train">
        <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl>{{ isWristband ? 'Wristband:' : 'Card Number:' }}</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="100" height="30" shadow text xl>{{this.cardNum}}</w-button>
        </div>
        <div v-if="isWristband" class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl>Time Remaining:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="200" height="30" shadow text xl>{{this.bandTimeRemaining}}</w-button>
        </div>
        <div v-if="isWristband" class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl>Package:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="200" height="30" shadow text xl>{{ selectedBandPackage === 'band90' ? '90-Minute Extension' : selectedBandPackage === 'bandBig' ? 'Big 3 Hours' : 'Small 3 Hours' }}</w-button>
        </div>
        <div v-if="!isWristband" class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl>Current Credits:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="100" height="30" shadow text xl>{{this.credits}}</w-button>
        </div>
        <div v-if="!isWristband" class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl>Credits Being Purchased:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="100" height="30" shadow text xl>{{this.totalAdd}}</w-button>
        </div>
        <div v-if="!isWristband" class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl>Credits After Checkout:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="100" height="30" shadow text xl>{{this.totalAfter}}</w-button>
        </div>
        <br>
        <div v-if="!isWristband" class="center-screen" v-show=showNewCardFee>
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl>New Card Activation:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="100" height="30" shadow text xl>${{(this.addNewCard).toFixed(2)}}</w-button>
        </div>
        <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl @click="">Subtotal:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="100" height="30" shadow text xl @click="">${{(this.subtotalOwed/100).toFixed(2)}}</w-button>
        </div>
        <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl @click="">Service Fee:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="100" height="30" shadow text xl @click="">${{(this.serviceOwed/100).toFixed(2)}}</w-button>
        </div>
        <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl @click="">Sales Tax:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="100" height="30" shadow text xl @click="">${{(this.taxOwed/100).toFixed(2)}}</w-button>
        </div>
        <div class="center-screen">
        <w-button class="ma1" bg-color="secondary" width="250" height="30" shadow text xl @click="">Total:</w-button>
        <br>
        <w-button class="ma1" bg-color="secondary" width="100" height="30" shadow text xl @click="">${{(this.totalOwed/100).toFixed(2)}}</w-button>
        </div>
        <br>
        <div id="payment-form">
          <button v-show="applePay" class="apple-pay-button" @click="handleApplePay()"></button>
          <button v-show="googlePay" class="google-pay-button" @click="handleGooglePay()"><span class="google-pay-label">Buy with</span><svg class="google-pay-mark" width="41" height="17" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M19.526 2.635v4.083h2.518c.6 0 1.096-.202 1.488-.605.403-.402.605-.882.605-1.437 0-.544-.202-1.018-.605-1.422-.392-.413-.888-.62-1.488-.62h-2.518zm0 5.52v4.736h-1.504V1.198h3.99c1.013 0 1.873.337 2.582 1.012.72.675 1.08 1.497 1.08 2.466 0 .991-.36 1.819-1.08 2.482-.697.665-1.559.996-2.583.996h-2.485v.001zm7.668 2.287c0 .392.166.718.499.98.332.26.722.391 1.168.391.633 0 1.196-.234 1.692-.701.497-.469.744-1.019.744-1.65-.469-.37-1.123-.555-1.962-.555-.61 0-1.12.148-1.528.442-.409.294-.613.657-.613 1.093m1.946-5.815c1.112 0 1.989.297 2.633.89.642.594.964 1.408.964 2.442v4.932h-1.439v-1.11h-.065c-.622.914-1.45 1.372-2.486 1.372-.882 0-1.621-.262-2.215-.784-.594-.523-.891-1.176-.891-1.96 0-.828.313-1.486.94-1.976s1.463-.735 2.51-.735c.892 0 1.629.163 2.206.49v-.344c0-.522-.207-.966-.621-1.33a2.132 2.132 0 0 0-1.455-.547c-.84 0-1.504.353-1.995 1.062l-1.324-.834c.73-1.045 1.81-1.568 3.238-1.568m11.853.262l-5.02 11.53H34.42l1.864-4.034-3.302-7.496h1.635l2.387 5.749h.032l2.322-5.75z" fill="#FFF"/><path d="M13.448 7.134c0-.473-.04-.93-.116-1.366H6.988v2.588h3.634a3.11 3.11 0 0 1-1.344 2.042v1.68h2.169c1.27-1.17 2.001-2.9 2.001-4.944" fill="#4285F4"/><path d="M6.988 13.7c1.816 0 3.344-.595 4.459-1.621l-2.169-1.681c-.603.406-1.38.643-2.29.643-1.754 0-3.244-1.182-3.776-2.774H.978v1.731a6.728 6.728 0 0 0 6.01 3.703" fill="#34A853"/><path d="M3.212 8.267a4.034 4.034 0 0 1 0-2.572V3.964H.978A6.678 6.678 0 0 0 .261 6.98c0 1.085.26 2.11.717 3.017l2.234-1.731z" fill="#FABB05"/><path d="M6.988 2.921c.992 0 1.88.34 2.58 1.008v.001l1.92-1.918C10.324.928 8.804.262 6.989.262a6.728 6.728 0 0 0-6.01 3.702l2.234 1.731c.532-1.592 2.022-2.774 3.776-2.774" fill="#E94235"/></g></svg></button>
          <div id="cash-app-pay" v-show="cashAppPay"></div>
          <button v-show="afterpay" class="pay-method-button" @click="handleAfterpay()"><span>Pay Over Time with</span><svg class="cashapp-mark" width="22" height="22" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><path fill="#00D632" d="M41.7 0c6.4 0 9.6 0 13.1 1.1a13.6 13.6 0 018.1 8.1C64 12.7 64 15.9 64 22.31v19.37c0 6.42 0 9.64-1.1 13.1a13.6 13.6 0 01-8.1 8.1C51.3 64 48.1 64 41.7 64H22.3c-6.42 0-9.64 0-13.1-1.1a13.6 13.6 0 01-8.1-8.1C0 51.3 0 48.1 0 41.69V22.3c0-6.42 0-9.64 1.1-13.1a13.6 13.6 0 018.1-8.1C12.7 0 15.9 0 22.3 0z"/><path fill="#FFF" d="M42.47 23.8c.5.5 1.33.5 1.8 0l2.5-2.6c.53-.5.5-1.4-.06-1.94a19.73 19.73 0 00-6.72-3.84l.79-3.8c.17-.83-.45-1.61-1.28-1.61h-4.84a1.32 1.32 0 00-1.28 1.06l-.7 3.38c-6.44.33-11.9 3.6-11.9 10.3 0 5.8 4.51 8.29 9.28 10 4.51 1.72 6.9 2.36 6.9 4.78 0 2.49-2.38 3.95-5.9 3.95-3.2 0-6.56-1.07-9.16-3.68a1.3 1.3 0 00-1.84 0l-2.7 2.7a1.36 1.36 0 000 1.92c2.1 2.07 4.76 3.57 7.792 4.4l-.74 3.57c-.17.83.44 1.6 1.27 1.61l4.85.04a1.32 1.32 0 001.3-1.06l.7-3.39C40.28 49.07 45 44.8 45 38.57c0-5.74-4.7-8.16-10.4-10.13-3.26-1.21-6.08-2.04-6.08-4.53 0-2.42 2.63-3.38 5.27-3.38 3.36 0 6.59 1.39 8.7 3.29z"/></svg><span>Afterpay</span></button>
          <div id="afterpay-attach" style="position:absolute;width:0;height:0;overflow:hidden"></div>
          <button class="pay-method-button" @click="openCardOverlay()">Pay with Credit Card</button>
          <button class="pay-method-button" @click="openGiftCardOverlay()">Pay with Gift Card</button>
          <button class="pay-method-button cancel-button" @click="pageSwitch(-1);clear();clearAdd();resetPaymentFields();">Cancel</button>
        </div>
      </div>

    </main>

<!--Footer-->
    <footer v-show=showFooter>
    </footer>

<!--Overlays-->
    <!--Read QR Overlay-->
    <w-overlay
  v-model="showOverlay"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="stream">
      <qr-stream @decode="onDecode" class="mb">
        <div style="color: red;" class="frame"></div>
      </qr-stream>
      <br>
      <w-button class="center-screen" bg-color="error" xl dark width="300" @click="showOverlay = false"> <w-icon class="mr2">wi-cross</w-icon>Cancel</w-button>
    </div>
</w-overlay>

<!--Error Overlay-->
<w-overlay
  v-model="error"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="center stream">
      <h1>Error</h1>
      <h2>Result: {{this.result}}</h2>
      <w-button bg-color="error" xl dark width="200" @click="error = false"> <w-icon class="mr2">wi-cross</w-icon>Cancel</w-button>
    </div>
</w-overlay>

<!--New Card Created Overlay-->
<w-overlay
  v-model="newCard"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="center stream">
      <h1>New Card Created</h1>
      <w-button bg-color="success" xl dark width="200" @click="newCard = false"> <w-icon class="mr2">wi-check</w-icon>OK</w-button>
    </div>
</w-overlay>

<!--Loading Overlay-->
<w-overlay
  v-model="isLoading"
  persistent="persistent"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="loading-spinner">
    <img src="./assets/spinner2.gif" alt="Loading..." />
  </div>
</w-overlay>

<!--Success Overlay-->
<w-overlay
  v-model="success"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="center stream">
      <h1>Transaction Successful!</h1>
      <img src="./assets/check.png" height="150">
      <h2>{{ successHeadline }}</h2>
      <w-button bg-color="success" xl dark width="200" @click="success = false;pageSwitch(-1);"> <w-icon class="mr2">wi-check</w-icon>Close</w-button>
    </div>
</w-overlay>

<!--Attractions Pricing Overlay-->
<w-overlay
  v-model="attractions"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="center stream">
      <h1>Attraction Credits</h1>
      <img src="./assets/points.jpg" height="300">
      <w-button bg-color="success" xl dark width="200" @click="attractions = false"> <w-icon class="mr2">wi-check</w-icon>Close</w-button>
    </div>
</w-overlay>

<!--Total Pkg1 Overlay-->
<w-overlay
  v-model="showPkg1"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="center stream">
      <h1>Package 1</h1>
      <label for="pkg1Num">How Many? </label>
      <input type="number" id="pkg1Num" name="pkg1Num" min="0" max="99" v-model.number="this.addPkg1"><br><br>
      <w-button bg-color="success" xl dark width="200" @click="showPkg1 = false"> <w-icon class="mr2">wi-check</w-icon>Confirm</w-button>
    </div>
</w-overlay>

<!--Total Pkg2 Overlay-->
<w-overlay
  v-model="showPkg2"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="center stream">
      <h1>Package 2</h1>
      <label for="pkg2Num">How Many? </label>
      <input type="number" id="pkg2Num" name="pkg2Num" min="0" max="99" v-model.number="this.addPkg2"><br><br>
      <w-button bg-color="success" xl dark width="200" @click="showPkg2 = false"> <w-icon class="mr2">wi-check</w-icon>Confirm</w-button>
    </div>
</w-overlay>

<!--Total Pkg3 Overlay-->
<w-overlay
  v-model="showPkg3"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="center stream">
      <h1>Package 3</h1>
      <label for="pkg3Num">How Many? </label>
      <input type="number" id="pkg3Num" name="pkg3Num" min="0" max="99" v-model.number="this.addPkg3"><br><br>
      <w-button bg-color="success" xl dark width="200" @click="showPkg3 = false"> <w-icon class="mr2">wi-check</w-icon>Confirm</w-button>
    </div>
</w-overlay>

<!--Total Pkg4 Overlay-->
<w-overlay
  v-model="showPkg4"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="center stream">
      <h1>Package 4</h1>
      <label for="pkg4Num">How Many? </label>
      <input type="number" id="pkg4Num" name="pkg4Num" min="0" max="99" v-model.number="this.addPkg4"><br><br>
      <w-button bg-color="success" xl dark width="200" @click="showPkg4 = false"> <w-icon class="mr2">wi-check</w-icon>Confirm</w-button>
    </div>
</w-overlay>

<!--Total Other Overlay-->
<w-overlay
  v-model="showOther"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="center stream">
      <h1>Individual Credits</h1>
      <label for="otherNum">How Many? </label>
      <input type="number" id="otherNum" name="otherNum" min="0" max="99" v-model.number="this.addOther"><br><br>
      <w-button bg-color="success" xl dark width="200" @click="showOther = false"> <w-icon class="mr2">wi-check</w-icon>Confirm</w-button>
    </div>
</w-overlay>

<!--Credit Card Overlay-->
<w-overlay
  v-model="showCardOverlay"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="center stream payment-overlay">
      <h2>Credit Card</h2>
      <div id="card-container"></div>
      <div class="payment-overlay-buttons">
        <w-button bg-color="error" xl dark width="140" @click="showCardOverlay = false"> <w-icon class="mr2">wi-cross</w-icon>Cancel</w-button>
        <w-button bg-color="success" xl dark width="140" @click="showCardOverlay = false; tokenizePayment()"> <w-icon class="mr2">wi-check</w-icon>Pay</w-button>
      </div>
    </div>
</w-overlay>

<!--Gift Card Overlay-->
<w-overlay
  v-model="showGiftCardOverlay"
  bg-color="rgba(250, 250, 250, 0.8)">
  <div class="center stream payment-overlay">
      <h2>Gift Card</h2>
      <div id="gift-card-container"></div>
      <div class="payment-overlay-buttons">
        <w-button bg-color="error" xl dark width="140" @click="showGiftCardOverlay = false"> <w-icon class="mr2">wi-cross</w-icon>Cancel</w-button>
        <w-button bg-color="success" xl dark width="140" @click="showGiftCardOverlay = false; handleGiftCard()"> <w-icon class="mr2">wi-check</w-icon>Pay</w-button>
      </div>
    </div>
</w-overlay>

  </w-app>
</div>
</template>

<script>
import { markRaw } from 'vue';
import { QrStream, QrCapture, QrDropzone } from 'vue3-qr-reader';
import { payments } from '@square/web-sdk';

export default ({
  name: 'App',
  components: {
    QrStream,
    QrCapture,
    QrDropzone
  },
  data: () => ({
    cardNum: 0,
    credits: 0,

    cardNumSuccess: 0,
    creditsSuccess: 0,
    successIsWristband: false,

    result: 0,

    userPage: true,
    noUser: true,

    success: false,
    attractions: false,

    addOther: 0,
    addPkg1: 0,
    addPkg2: 0,
    addPkg3: 0,
    addPkg4: 0,
    addNewCard: 0,

    totalOwed: 0,
    serviceOwed: 0,
    taxOwed: 0,
    subtotalOwed: 0,

    showPkg1: false,
    showPkg2: false,
    showPkg3: false,
    showPkg4: false,
    showOther: false,

    error: false,
    newCard: false,

    currPage: -1,
    lastPage: -1,
    showOverlay: false,
    showFooter: false,
    isLoading: false,

    goKart: false,
    miniGolf: false,
    train: false,

    pkg1Value: 110,
    pkg2Value: 170,
    pkg3Value: 290,
    pkg4Value: 600,
    pkg1Cost: 100,
    pkg2Cost: 150,
    pkg3Cost: 250,
    pkg4Cost: 500,

    payments: null,
    card: null,
    applePay: null,
    googlePay: null,
    cashAppPay: null,
    giftCard: null,
    afterpay: null,
    paymentToken: null,
    paymentRequest: null,
    inactivityTimer: null,
    // Re-entry guard for processTransaction (see there). isLoading can't
    // serve: callers set it true BEFORE invoking processTransaction.
    txnInFlight: false,
    showCardOverlay: false,
    showGiftCardOverlay: false,

    isWristband: false,
    bandTimeRemaining: '',
    bandType: null,
    bandInfo: false,
    selectedBandPackage: null,

    // True once waitForDelivery confirms the Square webhook landed the order.
    // Drives the success-overlay headline so we don't claim a balance/time
    // that hasn't actually posted yet.
    deliveryConfirmed: false,
}),
computed: {
    totalAdd: function() {
      return (this.addPkg1*this.pkg1Value)+(this.addPkg2*this.pkg2Value)+(this.addPkg3*this.pkg3Value)+(this.addPkg4*this.pkg4Value)+this.addOther
    },
    totalAfter: function() {
      return (this.credits*1)+(this.addPkg1*this.pkg1Value)+(this.addPkg2*this.pkg2Value)+(this.addPkg3*this.pkg3Value)+(this.addPkg4*this.pkg4Value)+this.addOther
    },
    subtotal: function() {
      return (this.addPkg1*this.pkg1Cost)+(this.addPkg2*this.pkg2Cost)+(this.addPkg3*this.pkg3Cost)+(this.addPkg4*this.pkg4Cost)+this.addOther
    },
    cartZero: function() {
      if ((this.addPkg1+this.addPkg2+this.addPkg3+this.addPkg4+this.addOther) < 1){
        return false
      } else{
        return true
      }
    },
    showNewCardFee: function() {
      if (this.addNewCard < 1){
        return false
      } else{
        return true
      }
    },
    successHeadline: function() {
      // Branches on deliveryConfirmed so a polling timeout doesn't tell the
      // customer their balance/time has already updated when it may not have.
      if (this.successIsWristband) {
        return this.deliveryConfirmed
          ? `Wristband ${this.cardNumSuccess} time has been added!`
          : `Wristband ${this.cardNumSuccess} time will appear shortly.`;
      }
      return this.deliveryConfirmed
        ? `Card ${this.cardNumSuccess} now has ${this.creditsSuccess} credits!`
        : `Card ${this.cardNumSuccess} — credits will appear shortly.`;
    }
  },
  async mounted() {
    try {
      this.payments = markRaw(await payments(process.env.VUE_APP_SQUARE_APP_ID, process.env.VUE_APP_SQUARE_LOCATION_ID));
    } catch (error) {
      console.error('Error initializing Square Payments:', error);
    }

    // Inactivity timeout — reset on any user interaction
    document.addEventListener('touchstart', this.resetInactivityTimer);
    document.addEventListener('click', this.resetInactivityTimer);
  },

  // Cart quantity clamps. HTML <input min/max> are just hints — users can
  // type past them or paste. Clamping in a watcher ensures the kiosk's
  // computed totals (subtotal, totalAfter) never display absurd values
  // and process-order's qty-range validation never trips on legitimate UI.
  watch: {
    // Each handler conditionally re-assigns only if the value changed, so a
    // clamp doesn't trigger an infinite watch loop.
    addPkg1(v) { const c = this.clampQty(v); if (c !== v) this.addPkg1 = c; },
    addPkg2(v) { const c = this.clampQty(v); if (c !== v) this.addPkg2 = c; },
    addPkg3(v) { const c = this.clampQty(v); if (c !== v) this.addPkg3 = c; },
    addPkg4(v) { const c = this.clampQty(v); if (c !== v) this.addPkg4 = c; },
    addOther(v) { const c = this.clampQty(v); if (c !== v) this.addOther = c; },
  },

  beforeUnmount() {
    document.removeEventListener('touchstart', this.resetInactivityTimer);
    document.removeEventListener('click', this.resetInactivityTimer);
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }
  },

methods: {

  async openCardOverlay() {
    this.showCardOverlay = true;
    await this.$nextTick();
    if (!this.card) {
      try {
        this.card = markRaw(await this.payments.card());
        await this.card.attach('#card-container');
      } catch (error) {
        console.error('Error initializing card:', error);
      }
    }
  },

  async openGiftCardOverlay() {
    this.showGiftCardOverlay = true;
    await this.$nextTick();
    if (!this.giftCard) {
      try {
        const gc = await this.payments.giftCard();
        await gc.attach('#gift-card-container');
        this.giftCard = markRaw(gc);
      } catch (error) {
        console.error('Error initializing gift card:', error);
      }
    }
  },

  resetInactivityTimer() {
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = null;
    }
    // Only run timer when a card is scanned
    if (!this.noUser) {
      this.inactivityTimer = setTimeout(() => {
        this.clearAdd();
        this.clear();
        this.resetPaymentFields();
      }, 180000); // 3 minutes
    }
  },

  async initMobilePayments() {
    // Create or update the payment request with the current total
    if (!this.paymentRequest) {
      this.paymentRequest = markRaw(this.payments.paymentRequest({
        countryCode: 'US',
        currencyCode: 'USD',
        total: {
          amount: `${(this.totalOwed / 100).toFixed(2)}`,
          label: 'Total',
        },
      }));
    } else {
      this.paymentRequest.update({
        total: {
          amount: `${(this.totalOwed / 100).toFixed(2)}`,
          label: 'Total',
        },
      });
    }

    // Initialize Apple Pay (once) — no .attach(), we provide our own button
    if (!this.applePay) {
      try {
        this.applePay = markRaw(await this.payments.applePay(this.paymentRequest));
      } catch (e) {
        console.warn('Apple Pay not available:', e.message);
      }
    }

    // Initialize Google Pay (once) — no .attach(), we provide our own button
    if (!this.googlePay) {
      try {
        this.googlePay = markRaw(await this.payments.googlePay(this.paymentRequest));
      } catch (e) {
        console.warn('Google Pay not available:', e.message);
      }
    }

    // Initialize Cash App Pay (once) — SDK renders button, event-based tokenization
    if (!this.cashAppPay) {
      try {
        const cap = await this.payments.cashAppPay(this.paymentRequest, {
          redirectURL: window.location.href,
          referenceId: crypto.randomUUID(),
        });
        await cap.attach('#cash-app-pay', {
          theme: 'dark',
          width: 'full',
          shape: 'semiround',
        });
        cap.addEventListener('ontokenization', (event) => {
          const { tokenResult } = event.detail;
          if (tokenResult.status === 'OK') {
            this.paymentToken = tokenResult.token;
            this.processTransaction();
          } else {
            console.error('Cash App Pay tokenization failed:', tokenResult.errors);
            this.result = "Cash App Pay could not be processed. Please try another payment method.";
            this.error = true;
          }
        });
        this.cashAppPay = markRaw(cap);
      } catch (e) {
        console.warn('Cash App Pay not available:', e.message);
      }
    }

    // Initialize Afterpay/Clearpay (once) — attach to hidden element, custom button calls .tokenize()
    if (!this.afterpay) {
      try {
        const ap = await this.payments.afterpayClearpay(this.paymentRequest);
        await ap.attach('#afterpay-attach');
        this.afterpay = markRaw(ap);
      } catch (e) {
        console.warn('Afterpay not available:', e.message);
      }
    }

  },

async tokenizePayment() {
      this.isLoading = true;
      try {
        const result = await this.card.tokenize();
        if (result.status === 'OK') {
          this.paymentToken = result.token;
          await this.processTransaction();
        } else {
          console.error('Tokenization failed:', result.errors);
          this.result = "Payment could not be processed. Please check your card details.";
          this.error = true;
        }
      } catch (error) {
        console.error('Error tokenizing payment:', error);
        this.result = "Payment could not be processed. Please try again.";
        this.error = true;
      }
      this.isLoading = false;
    },
    async handleApplePay() {
      this.isLoading = true;
      try {
        const result = await this.applePay.tokenize();
        if (result.status === 'OK') {
          this.paymentToken = result.token;
          await this.processTransaction();
        } else {
          console.error('Apple Pay tokenization failed:', result.errors);
          this.result = "Apple Pay could not be processed. Please try another payment method.";
          this.error = true;
        }
      } catch (error) {
        console.error('Error processing Apple Pay:', error);
        this.result = "Apple Pay could not be processed. Please try again.";
        this.error = true;
      }
      this.isLoading = false;
    },
    async handleGooglePay() {
      this.isLoading = true;
      try {
        const result = await this.googlePay.tokenize();
        if (result.status === 'OK') {
          this.paymentToken = result.token;
          await this.processTransaction();
        } else {
          console.error('Google Pay tokenization failed:', result.errors);
          this.result = "Google Pay could not be processed. Please try another payment method.";
          this.error = true;
        }
      } catch (error) {
        console.error('Error processing Google Pay:', error);
        this.result = "Google Pay could not be processed. Please try again.";
        this.error = true;
      }
      this.isLoading = false;
    },
    async handleAfterpay() {
      this.isLoading = true;
      try {
        const result = await this.afterpay.tokenize();
        if (result.status === 'OK') {
          this.paymentToken = result.token;
          await this.processTransaction();
        } else {
          console.error('Afterpay tokenization failed:', result.errors);
          this.result = "Afterpay could not be processed. Please try another payment method.";
          this.error = true;
        }
      } catch (error) {
        console.error('Error processing Afterpay:', error);
        this.result = "Afterpay could not be processed. Please try again.";
        this.error = true;
      }
      this.isLoading = false;
    },
    async handleGiftCard() {
      this.isLoading = true;
      try {
        const result = await this.giftCard.tokenize();
        if (result.status === 'OK') {
          this.paymentToken = result.token;
          await this.processTransaction();
        } else {
          console.error('Gift Card tokenization failed:', result.errors);
          this.result = "Gift card could not be processed. Please check the card number and try again.";
          this.error = true;
        }
      } catch (error) {
        console.error('Error processing Gift Card:', error);
        this.result = "Gift card could not be processed. Please try again.";
        this.error = true;
      }
      this.isLoading = false;
    },

  async loadCardNew(card){
    let temp = null;
    this.isLoading = true;
    try {
        const response = await fetch(`${process.env.VUE_APP_CHECKPOINTS_ENDPOINT}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${process.env.VUE_APP_SUPABASE_KEY}`},
            body: JSON.stringify({ 'cardnum': card }),
            signal: this.timeoutSignal(15000),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const postData = await response.json();
        this.isLoading = false;
        temp = postData.receivedData;
    } catch (postError) {
        console.error('Error during POST request:', postError);
        this.result = postError.message;
        this.error = true;
        this.isLoading = false;
        return;
    }

    // Handle both response shapes from webhook-listener:
    // - "Card Created" (legacy): existing checkpoints() RPC auto-creates a row
    // - null/undefined (new): get_card_credits() RPC, read-only, returns NULL
    //   if no card exists. Forward-compat for the webhook-listener migration
    //   that moves Cards auto-creation to the Square-HMAC-gated webhook only.
    const isNewCard = temp === null || temp === undefined || temp === "Card Created";
    const isExistingCard = typeof temp === 'number' || (typeof temp === 'string' && /^\d+$/.test(temp));

    if (isNewCard) {
      this.cardNum = card;
      this.cardNumSuccess = card;
      this.result = "New Card";
      this.newCard = true;
      this.addNewCard = 1;
      this.credits = 0;
      this.noUser = false;
      this.resetInactivityTimer();
      this.pageSwitch(0);
    } else if (isExistingCard) {
      this.cardNum = card;
      this.cardNumSuccess = card;
      this.credits = Number(temp);
      this.noUser = false;
      this.resetInactivityTimer();
      this.pageSwitch(0);
    } else {
      this.result = "Failed to load card data";
      this.error = true;
      this.isLoading = false;
    }
    this.isLoading = false;
  },

  async loadBandTime(band) {
    this.isLoading = true;
    try {
      const response = await fetch(`${process.env.VUE_APP_CHECKPOINTS_ENDPOINT}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${process.env.VUE_APP_SUPABASE_KEY}` },
        body: JSON.stringify({ bandnum: band }),
        signal: this.timeoutSignal(15000),
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const postData = await response.json();
      const result = postData.receivedData;
      this.bandType = postData.bandType || null;

      if (typeof result === 'string') {
        this.cardNum = band;
        this.cardNumSuccess = band;
        this.noUser = false;
        this.resetInactivityTimer();

        if (result.startsWith('Success!')) {
          const displayPart = result.split('|')[0].replace('Success! ', '').trim();
          this.bandTimeRemaining = displayPart;
          this.pageSwitch(3);
        } else if (result.startsWith('Expired at')) {
          this.bandTimeRemaining = 'Expired';
          this.pageSwitch(3);
        } else if (result === 'Wristband not Activated') {
          this.result = 'Wristband not Activated';
          this.error = true;
        } else {
          this.result = result;
          this.error = true;
        }
      } else {
        this.result = "Failed to check wristband";
        this.error = true;
      }
    } catch (postError) {
      console.error('Error checking wristband time:', postError);
      this.result = postError.message;
      this.error = true;
    }
    this.isLoading = false;
  },

  selectBandPackage(pkg) {
    this.selectedBandPackage = pkg;
    this.loadCheckoutTotals();
  },

  async loadCheckoutTotals(){
    this.isLoading = true;

    if (this.isWristband) {
      // Wristband checkout flow
      if (!this.selectedBandPackage) {
        this.result = "Please select a wristband package";
        this.error = true;
        this.isLoading = false;
        return;
      }
      let temp = null;
      try {
        const response = await fetch(`${process.env.VUE_APP_CALCULATE_ORDER_ENDPOINT}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${process.env.VUE_APP_SUPABASE_KEY}` },
          body: JSON.stringify({
            band90: this.selectedBandPackage === 'band90' ? "1" : "0",
            bandBig: this.selectedBandPackage === 'bandBig' ? "1" : "0",
            bandSmall: this.selectedBandPackage === 'bandSmall' ? "1" : "0",
            pkg1: "0", pkg2: "0", pkg3: "0", pkg4: "0", custom: "0", newcard: "0"
          }),
          signal: this.timeoutSignal(20000),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const postData = await response.json();
        temp = postData.receivedData;
      } catch (postError) {
        console.error('Error during POST request:', postError);
        this.result = postError.message;
        this.error = true;
        this.isLoading = false;
        return;
      }
      if (temp) {
        this.totalOwed = temp.total;
        this.serviceOwed = temp.service;
        this.subtotalOwed = temp.subtotal - temp.service;
        this.taxOwed = temp.tax;
        this.pageSwitch(2);
        await this.$nextTick();
        // Square SDK init can throw if this.payments is null (mounted hook
        // failed). Without this guard, the loading overlay sticks on and the
        // kiosk freezes — requires a refresh. Failing soft surfaces the issue
        // as a card-credit-card / gift-card fallback instead.
        try { await this.initMobilePayments(); } catch (e) { console.error('Mobile payments init failed:', e); }
        this.isLoading = false;
      } else {
        this.result = "Failed to calculate order";
        this.error = true;
        this.isLoading = false;
      }
      return;
    }

    // Card checkout flow (existing)
    if (this.cartZero){
    let temp = null;
    try {
        const response = await fetch(`${process.env.VUE_APP_CALCULATE_ORDER_ENDPOINT}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${process.env.VUE_APP_SUPABASE_KEY}`},
            body: JSON.stringify({"pkg1": `${this.addPkg1}`,
                                  "pkg2": `${this.addPkg2}`,
                                  "pkg3": `${this.addPkg3}`,
                                  "pkg4": `${this.addPkg4}`,
                                  "custom": `${this.addOther}`,
                                  // cardnum lets calculate-order derive the new-card fee from DB
                                  // state (card_needs_activation RPC) so the preview matches what
                                  // process-order will actually charge. newcard is still sent for
                                  // backward-compat but the server ignores it when cardnum is present.
                                  "cardnum": `${this.cardNum}`,
                                  "newcard": `${this.addNewCard}`}),
            signal: this.timeoutSignal(20000),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const postData = await response.json();
        temp = postData.receivedData;
    } catch (postError) {
        console.error('Error during POST request:', postError);
        this.result = postError.message;
        this.error = true;
        this.isLoading = false;
        return;
    }
    if (temp) {
      this.totalOwed = temp.total;
      this.serviceOwed = temp.service;
      this.subtotalOwed = temp.subtotal-temp.service;
      this.taxOwed = temp.tax;
      this.pageSwitch(2);
      await this.$nextTick();
      // See comment above on the wristband branch — same freeze guard.
      try { await this.initMobilePayments(); } catch (e) { console.error('Mobile payments init failed:', e); }
      this.isLoading = false;
    }else{
      this.result = "Failed to calculate order";
      this.error = true;
      this.isLoading = false;
    }
  }else{
    this.result = "Please add items to cart before checking out";
    this.error = true;
    this.isLoading = false;
  }
  },

  async resetPaymentFields() {
    try {
      if (this.card) {
        await this.card.destroy();
        this.card = null;
      }
    } catch (error) {
      console.error('Error resetting card field:', error);
    }
    try {
      if (this.giftCard) {
        await this.giftCard.destroy();
        this.giftCard = null;
      }
    } catch (error) {
      console.error('Error resetting gift card field:', error);
    }
  },

  async processTransaction(){
    // Re-entry guard: a double-fired tokenization event (Cash App's listener,
    // a double-tap racing the overlay) must not launch two charges. Payments
    // now use a fresh idempotency key per attempt, so nothing downstream
    // would block an accidental concurrent second attempt — this does.
    if (this.txnInFlight) return;
    this.txnInFlight = true;
    try {
    this.isLoading = true;
    // Start this transaction with no delivery confirmation. Set only after
    // waitForDelivery confirms the webhook actually landed the order.
    this.deliveryConfirmed = false;
    let temp = null;
    let orderId = null;
    let postData = null;
    // Fresh payment idempotency key for THIS attempt. Square binds payment
    // keys to the exact request params and consumes them even on failed
    // payments, so reusing one across attempts can only ever 400 (the 8/20
    // decline-retry lockout). Session-level double-charge protection lives
    // in `code` below, which process-order uses as the Square ORDER key.
    const attemptKey = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : `att-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    try {
        const response = await fetch(`${process.env.VUE_APP_PROCESS_ORDER_ENDPOINT}`, {
            method: 'POST',
            // 35s allows Square's order-create + payment-charge round-trips
            // (each can be a few seconds under load) plus margin. Longer than
            // other fetches because process-order does TWO Square round-trips.
            signal: this.timeoutSignal(35000),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${process.env.VUE_APP_SUPABASE_KEY}`,
            },
            body: JSON.stringify({"pkg1" : `${this.isWristband ? 0 : this.addPkg1}`,
                                  "pkg2" : `${this.isWristband ? 0 : this.addPkg2}`,
                                  "pkg3" : `${this.isWristband ? 0 : this.addPkg3}`,
                                  "pkg4" : `${this.isWristband ? 0 : this.addPkg4}`,
                                  "custom" : `${this.isWristband ? 0 : this.addOther}`,
                                  "newcard" : `${this.isWristband ? 0 : this.addNewCard}`,
                                  "band90" : `${this.selectedBandPackage === 'band90' ? 1 : 0}`,
                                  "bandBig" : `${this.selectedBandPackage === 'bandBig' ? 1 : 0}`,
                                  "bandSmall" : `${this.selectedBandPackage === 'bandSmall' ? 1 : 0}`,
                                  "cardnum" : `${this.cardNum}`,
                                  "token" : `${this.paymentToken}`,
                                  "attempt" : `${attemptKey}`,
                                  // Session key (localStorage, 5-min TTL): process-order uses it
                                  // as the Square ORDER idempotency key, so every retry of this
                                  // checkout reuses ONE order — if an earlier attempt actually
                                  // charged but the response was lost, the server sees the order
                                  // already paid and returns success without charging again.
                                  "code" : `${this.getOrCreateIdempotencyKey()}` }),
        });

        // Parse body even on non-OK to surface the server's specific error
        // (e.g. "Invalid cardnum", "Order is empty") instead of a generic
        // HTTP status code. Falls back to status if body isn't JSON.
        postData = await response.json().catch(() => ({}));
        if (!response.ok) {
            throw new Error(postData.error || `HTTP error! status: ${response.status}`);
        }
        temp = postData.receivedData;
        orderId = postData.orderId || null;
    } catch (postError) {
        console.error('Error during POST request:', postError);
        this.result = postError.message;
        this.error = true;
        this.paymentToken = null;
        this.isLoading = false;
        return;
    }

    if (temp === "Payment Successful") {
      // Wait briefly for the Square webhook to actually deliver credits/hours
      // before showing success. If delivery doesn't confirm within 15s, still
      // show success (Square accepted the payment) — square-webhook-listener
      // will email-alert ops if delivery actually fails downstream. The
      // success-overlay headline branches on this flag so we don't claim a
      // balance/time that hasn't actually posted yet.
      const delivered = await this.waitForDelivery(orderId);
      this.deliveryConfirmed = delivered;
      this.cardNumSuccess = this.cardNum;
      this.creditsSuccess = this.totalAfter;
      this.successIsWristband = this.isWristband;
      this.success = true;
      this.clearIdempotencyKey();
      this.paymentToken = null;
      this.clearAdd();
      this.clear();
      this.resetPaymentFields();
      this.pageSwitch(-1);
      this.isLoading = false;
    } else if (temp) {
      this.result = "Payment Failed";
      this.error = true;
      this.paymentToken = null;
      this.isLoading = false;
    } else {
      this.result = "Transaction failed";
      this.error = true;
      this.paymentToken = null;
      this.isLoading = false;
    }
    } finally { this.txnInFlight = false; }
  },

  onDecode (decodedString) {
      if (/^\d{4,5}$/.test(decodedString)) {
        this.cardNum = decodedString;
        this.isWristband = false;
        this.loadCardNew(decodedString);
        this.showOverlay = false;
      } else if (/^U\d{4,5}$/i.test(decodedString)) {
        this.cardNum = decodedString.toUpperCase();
        this.isWristband = true;
        this.loadBandTime(this.cardNum);
        this.showOverlay = false;
      } else {
        this.showOverlay = false;
        this.result = "Invalid QR Code";
        this.error = true;
      }
  },

  // Bounded timeout for fetch. Browsers' implicit fetch timeout is several
  // minutes — without this, a TCP-stalled connection (network drops in a
  // way that doesn't RST) freezes the kiosk because isLoading=true stays
  // true and the loading overlay covers the screen. Inactivity timer
  // doesn't rescue (doesn't reset isLoading). Result: kiosk unusable until
  // power-cycle. Throws AbortError on timeout, caught by callers' try/catch.
  timeoutSignal(ms) {
    if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
      return AbortSignal.timeout(ms);
    }
    // Fallback for older browsers (kiosk presumably modern, but defensive).
    const ctrl = new AbortController();
    setTimeout(() => ctrl.abort(), ms);
    return ctrl.signal;
  },

  // Persistent SESSION key for Square. process-order uses it as the Square
  // ORDER idempotency key: every retry within one checkout session lands on
  // the same order, so a lost-response retry finds the order already paid
  // and is reported as success instead of charging again. (It is no longer
  // the PAYMENT idempotency key — those are per-attempt via `attempt`,
  // because Square consumes payment keys even on declines.) 5-minute TTL
  // outlives any realistic retry but not the next customer; success/cancel/
  // inactivity-reset all clear it.
  getOrCreateIdempotencyKey() {
    const STORAGE_KEY = 's49_idempotency_key';
    const TTL_MS = 5 * 60 * 1000;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const { key, expiresAt } = JSON.parse(raw);
        if (key && typeof expiresAt === 'number' && expiresAt > Date.now()) {
          return key;
        }
      }
    } catch (e) { /* localStorage disabled or corrupted JSON — fall through */ }
    const key = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : `s49-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ key, expiresAt: Date.now() + TTL_MS }));
    } catch (e) { /* best-effort persistence */ }
    return key;
  },

  clearIdempotencyKey() {
    try { localStorage.removeItem('s49_idempotency_key'); } catch (e) { /* noop */ }
  },

  // Poll the webhook-listener for "did Square's async webhook finish landing
  // credits/hours for this order?". If yes within 15s, the customer's success
  // screen reflects confirmed delivery. If no (network slow, webhook delayed),
  // we still show success because Square accepted the payment — the
  // square-webhook-listener will alert ops by email if delivery actually fails.
  async waitForDelivery(orderId) {
    if (!orderId) return false;
    const maxMs = 15000;
    const intervalMs = 750;
    const start = Date.now();
    const body = this.isWristband
      ? { orderid: orderId, bandnum: this.cardNum }
      : { orderid: orderId, cardnum: Number(this.cardNum) };
    while (Date.now() - start < maxMs) {
      try {
        const r = await fetch(`${process.env.VUE_APP_CHECKPOINTS_ENDPOINT}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${process.env.VUE_APP_SUPABASE_KEY}` },
          body: JSON.stringify(body),
          // Shorter timeout than other fetches because we have multiple
          // poll iterations within the 15s window — better to fail one
          // poll quickly and try the next.
          signal: this.timeoutSignal(5000),
        });
        if (r.ok) {
          const data = await r.json();
          if (data && data.delivered === true) return true;
        }
      } catch (e) {
        console.warn('Delivery poll error:', e);
      }
      await new Promise(res => setTimeout(res, intervalMs));
    }
    return false;
  },

  clear (){
    this.credits = 0;
    this.cardNum = 0;
    this.noUser = true;
    this.goKart = false;
    this.miniGolf = false;
    this.train = false;
    this.bandInfo = false;
    this.isWristband = false;
    this.bandTimeRemaining = '';
    this.bandType = null;
    this.selectedBandPackage = null;
    this.showCardOverlay = false;
    this.showGiftCardOverlay = false;
    // Clear idempotency key on session-end so a different customer's first
    // Pay attempt can't accidentally inherit a key that Square might have
    // already paired with the previous customer's actual charge.
    this.clearIdempotencyKey();
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = null;
    }
    this.pageSwitch(this.currPage);
  },

  clearAdd (){
    this.addOther = 0;
    this.addPkg1 = 0;
    this.addPkg2 = 0;
    this.addPkg3 = 0;
    this.addPkg4 = 0;
    this.addNewCard = 0;
    // Reset wristband selection too — clear() also does this but clearAdd is
    // called on its own from "Clear Cart" and a few other paths.
    this.selectedBandPackage = null;
    // NOTE: deliveryConfirmed is intentionally NOT reset here. clearAdd runs
    // inside the success branch of processTransaction *after* we set
    // deliveryConfirmed = delivered. Resetting it here would clobber the
    // value before Vue renders the success overlay, making the headline
    // always read "credits will appear shortly." It's reset at the start of
    // the next processTransaction call instead.
  },

  // Defense-in-depth clamp for the cart +1 buttons. server (process-order)
  // already rejects qty > 99 with a 400, but no reason to even let the kiosk
  // get into that state.
  incrementCart(field) {
    if (typeof this[field] !== 'number' || this[field] < 99) {
      this[field] = Math.min(99, (this[field] || 0) + 1);
    }
  },

  // Clamp arbitrary input (used by the "How Many?" number-input watchers).
  // Coerces NaN/non-numbers to 0, floors fractions, bounds to [0, 99].
  clampQty(v) {
    const n = Number(v);
    if (!Number.isFinite(n)) return 0;
    return Math.max(0, Math.min(99, Math.floor(n)));
  },

  pageSwitch(page) {
    this.lastPage = this.currPage;
    this.currPage = page;

    this.userPage = false;
    this.goKart = false;
    this.miniGolf = false;
    this.train = false;
    this.bandInfo = false;
    this.showFooter = false;

    if (!this.noUser) {
      switch (page) {
        case -1: this.userPage = true; break;
        case 0: this.goKart = true; break;
        case 1: this.miniGolf = true; break;
        case 2: this.train = true; break;
        case 3: this.bandInfo = true; break;
        default: this.userPage = true; break;
      }
    } else {
      this.userPage = true;
    }
    return null;
  }
  }

});


</script>

<style>
/* === Global Font Application === */
.w-app {
  font-family: var(--font-body);
  padding: 4px;
  background-color: var(--color-cream);
  color: var(--color-charcoal);
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-heading);
  color: var(--color-charcoal);
}

/* === Layout === */
header, footer, main {
  margin: 4px;
  padding: 12px;
}

header {
  background-color: var(--color-walnut);
  color: var(--color-text-light);
  min-height: 150px;
  border-radius: var(--radius-md);
}

footer {
  background-color: var(--color-walnut);
  color: var(--color-text-light);
  min-height: 60px;
  border-radius: var(--radius-md);
}

main {
  background-color: var(--color-cream-dark);
  border-radius: var(--radius-md);
}

/* === Input Styles === */
input[type="text"],
input[type="number"],
input[type="password"] {
  font-family: var(--font-body);
  font-size: 24px;
  padding: var(--space-sm) var(--space-md);
  border: var(--border-subtle);
  border-radius: var(--radius-sm);
  background-color: var(--color-parchment);
  color: var(--color-charcoal);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

input[type="text"]:focus,
input[type="number"]:focus,
input[type="password"]:focus {
  outline: none;
  border-color: var(--color-copper);
  box-shadow: 0 0 0 3px rgba(212, 118, 10, 0.2);
}

input[type="number"] {
  width: 195px;
}

/* === Button Overrides === */
.w-button {
  border-radius: var(--radius-sm) !important;
  font-family: var(--font-body) !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
  transition: transform var(--transition-fast), box-shadow var(--transition-fast) !important;
}

.w-button:active {
  transform: scale(0.97) !important;
}

.w-button.w-button--shadow {
  box-shadow: var(--shadow-button) !important;
}

/* === Layout Utilities === */
.center-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.stream {
  max-height: 300px;
  max-width: 300px;
  margin: auto;
}

.disable-dbl-tap-zoom {
  touch-action: manipulation;
}

/* === Payment Form === */
#payment-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-sm);
  margin: 0 auto;
  max-width: 400px;
}

#card-container, #gift-card-container {
  width: 100%;
  min-width: 280px;
}

.payment-overlay {
  max-width: 400px;
  min-width: 320px;
  padding: var(--space-xl);
  background: var(--color-parchment);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
}

.payment-overlay-buttons {
  display: flex;
  gap: var(--space-sm);
  justify-content: center;
  margin-top: var(--space-md);
}

/* === Payment Method Buttons (platform-specific) === */
.apple-pay-button {
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-type: buy;
  -apple-pay-button-style: black;
  width: 100%;
  height: 44px;
  cursor: pointer;
  border: none;
}

.google-pay-button {
  width: 100%;
  height: 44px;
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 16px;
  font-family: var(--font-body);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.google-pay-mark {
  height: 17px;
  flex-shrink: 0;
}

.pay-method-button {
  width: 100%;
  height: 44px;
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 16px;
  font-family: var(--font-body);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.cancel-button {
  background-color: #C62828;
}

.cashapp-mark {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

#cash-app-pay {
  width: 100%;
  height: 44px;
  border-radius: var(--radius-sm);
  overflow: hidden;
}

/* === Loading Spinner === */
.loading-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background-color: var(--color-parchment);
  border-radius: var(--radius-lg);
  padding: var(--space-xl);
  box-shadow: var(--shadow-lg);
}

/* === Overlay Cards === */
.overlay-card {
  background-color: var(--color-parchment);
  border-radius: var(--radius-lg);
  padding: var(--space-xl);
  box-shadow: var(--shadow-lg);
  text-align: center;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
}

.overlay-card h1 {
  font-family: var(--font-heading);
  color: var(--color-charcoal);
  border-bottom: var(--border-copper);
  padding-bottom: var(--space-sm);
  margin-bottom: var(--space-md);
}
</style>
